<template>
	<div class="contest-panel-view">
		<router-link :to="{ path: 'main-data'}" replace>
			<v-btn>Parametry konkursu</v-btn>
		</router-link>
		<router-link :to="{ path: 'documents'}" replace>
			<v-btn>Dokumenty</v-btn>
		</router-link>
		<router-link :to="{ path: 'tasks'}" replace>
			<v-btn>Zadania</v-btn>
		</router-link>
		<router-link :to="{ path: 'financial-limits'}" replace>
			<v-btn>Limity finansowe</v-btn>
		</router-link>
		<router-link :to="{ path: 'constant-fields'}" replace>
			<v-btn>Pola stałe</v-btn>
		</router-link>
		<router-link :to="{ path: 'forms'}" replace>
			<v-btn>Formularze</v-btn>
		</router-link>
		<router-link :to="{ path: 'users'}" replace>
			<v-btn>Użytkownicy konkursu</v-btn>
		</router-link>
		<router-link :to="{ path: 'committees'}" replace>
			<v-btn>Komisje</v-btn>
		</router-link>
		<router-link :to="{ path: 'rating-parameters'}" replace>
			<v-btn>Parametry oceny</v-btn>
		</router-link>
		<router-link :to="{ path: 'action'}" replace>
			<v-btn>Akcja</v-btn>
		</router-link>
		<router-view/>
	</div>
</template>

<script>
	export default {
		name: "ContestPanelView",

    methods: {
      updateNames(name, shortName) {
        this.$parent.updateNames(name, shortName);
      }
    }
	};
</script>

<style>

.contest-panel-view a {
	color: #fff !important;
}

</style>
